import { Typography } from '@mui/material';
import { styled } from '@mui/styles';

export const ModalWrapper = styled('div')(({ theme }) => ({
  textAlign: 'left'
}));

export const MainContentWrapper = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(2)
}));

export const TypographyWrapper = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),

  '& > ul': {
    paddingLeft: theme.spacing(2.5)
  }
}));

export const TypographyWithIconWrapper = styled(TypographyWrapper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 0
}));

export const TypographyWithBottomTextWrapper = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.gray.main,
  lineHeight: theme.spacing(3)
}));

export const TypographyBoldedWrapper = styled(Typography)(({ theme }) => ({
  fontWeight: 600
}));
